import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal, untracked } from '@angular/core';
import { Contract } from '@models/contract';
import { ContractWidget } from '@models/contract-widgets';
import { PlaceholderCardComponent } from 'app/customer-portal/components';
import { DamageReportsService } from 'app/customer-portal/damage-reports';
import { PortalCollapsibleComponent } from '../../components/portal-collapsible/portal-collapsible.component';
import { finalize, tap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReportedDamagesListItemComponent } from 'app/customer-portal/damage-reports/components/reported-damages-list-item/reported-damages-list-item.component';
import { DamageReportState } from '@models/damage-report';

@Component({
    selector: 'app-reported-damages-widget',
    imports: [PlaceholderCardComponent, PortalCollapsibleComponent, ReportedDamagesListItemComponent],
    templateUrl: './reported-damages-widget.component.html',
    styleUrl: './reported-damages-widget.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.hide]': '(!pending() && !damageReports().length)',
    },
})
export class ReportedDamagesWidgetComponent implements ContractWidget {
    public contract = input.required<Contract>();

    private damageReportService = inject<DamageReportsService>(DamageReportsService);
    protected damageReports = toSignal(this.damageReportService.damagesForSelectedContract$);

    protected pending = signal(false);

    protected nbrReportsNotComplete = computed(() => {
        const reports = this.damageReports() || [];
        return reports.filter((report) => report.state !== DamageReportState.COMPLETED).length;
    });

    public constructor() {
        effect(() => {
            const contract = this.contract();

            this.pending.set(true);
            untracked(() => {
                this.damageReportService
                    .fetch(contract)
                    .pipe(
                        tap(() => this.damageReportService.selectContract(contract)),
                        finalize(() => {
                            this.pending.set(false);
                        }),
                    )
                    .subscribe();
            });
        });
    }
}
